import { useLocation, Link } from "react-router-dom";
import { PRODUCT } from "@/constants/testIds";

export function StickyBuy() {
  const loc = useLocation();
  const showOn = ["/preshhgo", "/product/"];
  const show = showOn.some((p) => loc.pathname.startsWith(p));
  if (!show) return null;
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-black/80 backdrop-blur-xl border-t border-white/10 px-4 py-3">
      <Link to="/preshhgo" data-testid={PRODUCT.stickyBuy}
        className="block w-full text-center bg-[#00B5D8] text-black font-bold rounded-full py-3">
        Buy Preshh GO
      </Link>
    </div>
  );
}
